/**
 * Out-of-play rollout bands (Cole's multiplayer notes, 2026-10-18): Turf
 * War's sudden death leaves only the playoff zone lit, and Line Four blacks
 * out a full column. One look for both: the band's span painted near-black,
 * its standing label and right-rail label gone, its cross-line dark.
 *
 * Built only from fields every receiver already draws (`fillColor`,
 * `fillOpacity`, `lineColor`) plus `hidden` for the label (10-17 receivers
 * on), so an older TV bundle still shows the blacked-out zone; one from
 * before 10-17 keeps the label over it.
 */
import type { PuttSceneRolloutBand } from './SceneContent';

/** Near-black, a shade darker than Turf War's dead gaps (#05070C at 0.55). */
export const BLACKOUT_BAND_COLOR = '#020306';
export const BLACKOUT_BAND_OPACITY = 0.86;

/** The band painted out of play: near-black, no labels, a dark cross-line. */
export function blackoutRolloutBand(band: PuttSceneRolloutBand): PuttSceneRolloutBand {
  const { rightLabel: _rightLabel, ...rest } = band;
  return {
    ...rest,
    fillColor: BLACKOUT_BAND_COLOR,
    fillOpacity: BLACKOUT_BAND_OPACITY,
    lineColor: BLACKOUT_BAND_COLOR,
    hidden: true,
  };
}

